import { render, staticRenderFns } from "./add-sub-require.vue?vue&type=template&id=63c1daac&scoped=true&"
import script from "./add-sub-require.vue?vue&type=script&lang=js&"
export * from "./add-sub-require.vue?vue&type=script&lang=js&"
import style0 from "./add-sub-require.vue?vue&type=style&index=0&id=63c1daac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1daac",
  null
  
)

export default component.exports